import base from '@config/base.js'
import variables from '@config/variables.js'
import webview from '@config/webview.js'

const isWebView = process.env.WEBVIEW === '1'

export function getConfig() {
  return {
    fallbackLangMap: {
      az: ['en'],
      bd: ['en'],
      es: ['en'],
      tr: ['en'],
      'uz-Cyrl': ['uz'],
      default: [process.env.DEFAULT_LANG || 'ru'],
    },
    ...variables,
    ...base,
    ...(isWebView ? webview : {}),
  }
}
